export const dataLayerPush = (
  eventName: string,
  userId: string,
  optionalProp?: {
    fieldName: string;
    fieldValue: string | Array<string> | number | Object;
  }
) => {
  let dataLayerObject = {
    event: eventName,
    userId: userId,
  };

  optionalProp &&
    Object.defineProperty(dataLayerObject, optionalProp!.fieldName, {
      value: optionalProp!.fieldValue,
      enumerable: true,
      writable: true,
      configurable: true,
    });

  window!.dataLayer!.push(dataLayerObject);
};
